// extracted by mini-css-extract-plugin
export default {"cls1":"Z266s5MFpwMrcoAhGFbQ","cls2":"AQZE2zoUpl7BbVV8kId1 Z266s5MFpwMrcoAhGFbQ"};